var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card-statistics card cursor-pointer",
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "card-header" }, [
        _c("h4", { staticClass: "card-title" }, [_vm._v(" Vencidos ")]),
        _c(
          "p",
          { staticClass: "card-text font-small-2 me-25 mb-0 card-text" },
          [
            _vm._v(
              " Entre " + _vm._s(_vm.from) + " a " + _vm._s(_vm.to) + " dias "
            )
          ]
        )
      ]),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "mb-2 mb-xl-0 col" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", { staticClass: "avatar me-2 bg-light-danger" }, [
                _c("span", { staticClass: "avatar-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    },
                    [
                      _c("polyline", {
                        attrs: { points: "23 6 13.5 15.5 8.5 10.5 1 18" }
                      }),
                      _c("polyline", { attrs: { points: "17 6 23 6 23 12" } })
                    ]
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "ml-auto ",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("h4", { staticClass: "fw-bolder mb-0" }, [
                    _vm._v(_vm._s(_vm.total))
                  ]),
                  _c("p", { staticClass: "font-small-3 mb-0 card-text" }, [
                    _vm._v("Expedientes")
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }